import { $authHost } from "../../http";
import { 
    SERVICE_KIND_GET_REQUEST, SERVICE_KIND_GET_SUCCESS, SERVICE_KIND_GET_ERROR, 
    SERVICE_KIND_GET_BY_KEY_REQUEST, SERVICE_KIND_GET_BY_KEY_SUCCESS, SERVICE_KIND_GET_BY_KEY_ERROR, 
    SERVICE_KIND_ADD_REQUEST, SERVICE_KIND_ADD_SUCCESS, SERVICE_KIND_ADD_ERROR, 
    SERVICE_KIND_EDIT_REQUEST, SERVICE_KIND_EDIT_SUCCESS, SERVICE_KIND_EDIT_ERROR, 
    SERVICE_KIND_DELETE_REQUEST, SERVICE_KIND_DELETE_SUCCESS, SERVICE_KIND_DELETE_ERROR
} from "../constants/serviceKindConstants";

export const getServiceKinds = (args) => async (dispatch) => {
    try {
        dispatch({
            type: SERVICE_KIND_GET_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        const {data} = await $authHost.post(
            "/api/v1/serviceKind/query",
            args || {},
            config,
        );
        dispatch({
            type: SERVICE_KIND_GET_SUCCESS,
            payload: data.result,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: SERVICE_KIND_GET_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const getServiceKindByKey = (id) => async (dispatch) => {
    try {
        dispatch({
            type: SERVICE_KIND_GET_BY_KEY_REQUEST
        });

        const {data} = await $authHost.get(
            `/api/v1/serviceKind/${id}`,
        );
        dispatch({
            type: SERVICE_KIND_GET_BY_KEY_SUCCESS,
            payload: data,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: SERVICE_KIND_GET_BY_KEY_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const addServiceKind = ({ name, code, description }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: SERVICE_KIND_ADD_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.post(
            "/api/v1/serviceKind",
            { name, code, description },
            config,
        );
        dispatch(getServiceKinds(queryArgs || {}));
        dispatch({
            type: SERVICE_KIND_ADD_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: SERVICE_KIND_ADD_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const editServiceKind = ({ id, name, code, description }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: SERVICE_KIND_EDIT_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.put(
            "/api/v1/serviceKind",
            { id, name, code, description },
            config,
        );
        dispatch(getServiceKinds(queryArgs || {}));
        dispatch({
            type: SERVICE_KIND_EDIT_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: SERVICE_KIND_EDIT_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const deleteServiceKind = (id, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: SERVICE_KIND_DELETE_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.delete(
            "/api/v1/serviceKind",
            { data: { id } },
            config,
        );
        dispatch(getServiceKinds(queryArgs || {}));
        dispatch({
            type: SERVICE_KIND_DELETE_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: SERVICE_KIND_DELETE_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

